export default __webpack_public_path__ + "static/pdp--mobile-fe1c90f356e65d9a6051dc08fab86afc.jpg";